import styled from 'styled-components';
import { colorTypeHelper } from 'utils/colorUtility';

export const CardContainer = styled.div`
  box-shadow: ${(props) =>
    props.hovered ? '0px 15px 40px rgba(11, 26, 33, 0.1)' : '0px 3px 10px rgba(11, 26, 33, 0.08)'};
  cursor: ${(props) => (props.hovered && props.ctaLink ? 'pointer' : 'arrow')};
  height: 100%;
  transition: all 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  position: relative;
  display: flex;
  flex-direction: column;

  .card--top-left-icon {
    img {
      width: 40px;
      height: 40px;
    }
    position: absolute;
    top: 25px;
    left: 15px;
    z-index: 1;
  }

  .card--cover {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    background: ${({ coverBackColor }) =>
      colorTypeHelper[coverBackColor]
        ? `var(${colorTypeHelper[coverBackColor]})`
        : coverBackColor || 'var(--white)'};
    overflow: hidden;

    &.has-top-left-icon {
      margin-left: 40px;
    }

    .card--cover-wrapper {
      height: 100%;
      width: 100%;
      position: absolute !important;
      top: 0;
      left: 0;
    }

    .card--cover-overlay {
      position: absolute;
      z-index: 2;
      display: flex;
      align-self: center;
      width: auto;
      top: 50%;
      transform: translateY(-50%);
    }

    .card--cover-video {
      width: 100%;
      height: 100%;
    }

    .card--cover-image {
      width: 100%;
      height: 100%;
    }
  }

  .card--body {
    background: ${(props) => props.bodyBackColor || 'var(--white)'};
    height: 100%;

    &.has-top-left-icon {
      margin-left: 40px;
    }
  }

  .card--link {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
  }

  &.no-shadow {
    box-shadow: none;
  }

  &.side-cover {
    flex-direction: row;
    &.side-reverse {
      flex-direction: row-reverse;
    }

    .card--cover {
      flex: 1;
      overflow: hidden;
      min-height: 0;
      max-height: 100%;
      padding-top: calc((100% - 403px) * 0.5625);

      .card--cover-image {
        min-height: 0;
        max-height: 476px;
      }

      .card--cover-video {
        max-height: 100%;
        height: 100%;
      }
    }

    .card--body {
      width: 403px;
      max-width: 50%;
      height: auto;
    }

    @media (max-width: 767px) {
      .card--cover {
        width: 50%;
        padding-top: 28.125%;
      }

      .card--body {
        width: 50%;
      }
    }

    @media (max-width: 575px) {
      flex-direction: column;
      &.side-reverse {
        flex-direction: column;
      }

      .card--cover {
        width: 100%;
        flex: auto;
        padding-top: 56.25%;

        .card--cover-image,
        .card--cover-video {
          width: 100%;
          height: auto;
        }
      }

      .card--body {
        width: 100%;
        max-width: 100%;
        flex: 1;
      }
    }
  }

  &.simple-responsive {
    @media (max-width: 767px) {
      flex-direction: row;
      align-items: center;
      background: ${(props) => props.bodyBackColor || 'var(--white)'};

      .card--cover {
        min-width: 100px;
        min-height: 0;
        padding: 0;
        width: 100px;
        height: 100px;
      }

      .card--body {
        width: 100%;
      }
    }
  }
`;

export const CardsWrapperContainer = styled.div`
  height: 100%;
`;

export const CardBodyContainer = styled.div`
  padding: 32px;
  height: 100%;
  position: relative;

  &.simple-responsive {
    padding: 24px;
  }

  .ticker {
    margin-bottom: 5px;
    p {
      -webkit-text-size-adjust: none;
    }
  }

  p {
    margin: 0;
    padding: 0;
    text-align: ${(props) => props.align || 'left'};
    @media (max-width: 575px) {
      line-height: var(--line-height-140);
    }
  }

  &.with-footer-cta {
    .card--body-wrapper {
      padding-bottom: 65px;

      &.simple-card {
        padding-bottom: 30px;
      }
    }
  }

  .card--body-wrapper {
    &.with-footer-percent,
    &.with-footer-author {
      padding-bottom: 111px;
      height: 100%;
    }
  }

  @media (max-width: 767px) {
    padding: 24px;

    &.with-footer-cta {
      .card--body-wrapper {
        padding-bottom: 47px;
      }
    }

    &.simple-responsive {
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &.simple-responsive.with-footer-cta {
      .card--body-wrapper {
        padding-bottom: 0;
      }
    }

    .card--body-wrapper {
      &.with-footer-percent,
      &.with-footer-author {
        padding-bottom: 89px;
      }
    }
  }

  @media (max-width: 575px) {
    &.with-footer-cta {
      .card--body-wrapper.icon-card--body-wrapper {
        padding-bottom: 32px;
      }
    }

    .card--body-wrapper {
      &.with-footer-author {
        padding-bottom: 65px;
      }

      &.icon-card--body-wrapper {
        display: flex;

        .icon-card--text-container {
          margin-left: 20px;

          p {
            text-align: left;
          }
        }
      }
    }
  }
`;

export const CategoryContainer = styled.div`
  margin-bottom: 12px;
  overflow: hidden;
  position: relative;

  &:before {
    content: ' ';
    width: ${(props) => (props.hovered ? '0' : '50px')};
    background: linear-gradient(to right, #ffffff00, #ffffffff);
    position: absolute;
    height: 100%;
    right: 0;
  }

  @media (max-width: 767px) {
    margin-bottom: 8px;

    &.simple-responsive {
      display: none;
    }
  }
`;

export const FooterContainer = styled.div`
  font-family: var(--font-family-body);
  font-size: var(--font-size-16);
  font-weight: var(--font-weight-400);
  line-height: var(--line-height-110);
  color: ${(props) => (props.hovered ? 'var(--titan-blue-4)' : 'var(--titan-blue-3)')};
  position: absolute;
  bottom: 32px;
  text-align: ${(props) => props.align || 'left'};

  &.simple-responsive {
    bottom: 24px;
  }

  & > svg {
    vertical-align: middle;
    margin-left: 6px;
    margin-top: -1px;
  }

  @media (max-width: 767px) {
    font-size: var(--font-size-13);
    bottom: 24px;

    &.simple-responsive {
      position: relative;
      bottom: 0;
    }
  }

  @media (max-width: 575px) {
    &.icon-card-footer {
      left: 108px;
    }
  }
`;

export const CardGroupContainer = styled.div`
  .card-group--row {
    display: flex;
    margin: 0 -20px;

    .card-group--item {
      flex: 1;
      margin: 20px 20px;
      min-width: 0;

      &.empty-item {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
    }
  }

  @media (max-width: 991px) {
    .card-group--row {
      margin: 0 -10px;

      .card-group--item {
        margin: 10px 10px;
      }
    }
  }

  @media (max-width: 575px) {
    .card-group--row {
      flex-direction: column;
    }
  }
`;

export const ToolCardContainer = styled.div`
  text-align: ${(props) => props.textAlign};
  width: ${(props) => props.width};
  box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;
  height: 100%;
  background: var(${(props) => props.background}) !important;
  border-radius: 10px !important;
  overflow: hidden;
  top: 0;

  &:hover {
    box-shadow: 0 8px 24px 8px rgba(160, 161, 188, 0.14) !important;
    top: -4px;
  }

  .card--link {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  .tool-card--container {
    display: flex;
    flex-direction: column;

    .tool-card--image-container {
      width: 100%;
      height: 300px;
      padding: 50px 30px 0 0;

      .styles-container {
        height: 100%;

        .website-image {
          height: inherit;

          .tool-card--image {
            width: auto;
            height: 100%;
            picture > img {
              object-position: 100% 50%;
            }
          }
        }
      }
    }

    .tool-card--body-container {
      padding: 30px;

      .tool-card--content-container {
        padding-top: 10px;
        padding-bottom: 0;

        .tool-card--title {
          color: var(--white);
        }

        .tool-card--description {
          color: var(--white);
        }
      }
    }
  }

  @media (max-width: 767px) {
    .tool-card--container {
      .tool-card--body-container {
        padding: 20px;

        .tool-card--content-container {
          padding-top: 10px;
        }
      }
    }
  }

  @media (max-width: 575px) {
    .tool-card--container {
      .tool-card--content-container {
        padding-top: 22px;
      }
    }
  }
`;
